export const PULLING_CREATE_TEEN = {
  VIEW_ADD_KID_CREATING_KID_ACCOUNT: 'view_add_kid_creating_kid_account',
  VIEW_ADD_KID_CONFIRMATION_SUCCESS: 'view_add_kid_confirmation_success',
  VIEW_ADD_KID_CONFIRMATION_ERROR: 'view_add_kid_confirmation_error',
};
